import { withTranslation } from "next-i18next";
import { useState } from "react";
import Button from "@components/core/Button";
import ProductDetailsOffCanvas from "./ProductDetailsOffCanvas";

function ProductDetails({ product, t }) {
  const [detailsOffcanvasOpened, setDetailsOffcanvasOpened] = useState(false);

  function openDetailsOffcanvas() {
    setDetailsOffcanvasOpened(true);
  }

  function closeDetailsOffcanvas() {
    setDetailsOffcanvasOpened(false);
  }

  return (
    <section className="mb-4">
      <p className="mb-2 font-weight-bold">
        {t("product:product_description_title")}
      </p>

      {product.description && (
        <p className="product-description">
          {product.description}
        </p>
      )}

      <Button
        variant="link-primary"
        className="no-underline"
        onClick={openDetailsOffcanvas}
      >
        {t("product:see_more")}
      </Button>

      <ProductDetailsOffCanvas
        product={product}
        opened={detailsOffcanvasOpened}
        close={closeDetailsOffcanvas}
      />
    </section>
  );
}

export default withTranslation("product")(ProductDetails);


